import { Mui } from '@onedesign/ui';

const { styled, FormControl } = Mui;

export const StyledFormControlResetPassword = styled(FormControl)({
  textAlign: 'left',
  marginTop: '1.5rem',
  width: '100%',
});
